import { useEffect, useState } from 'react'
import { get } from 'lodash'
import * as yup from 'yup'
import Drawer from '@material-ui/core/Drawer'
import usePostData from 'hooks/post-data'
import { FormTitle } from 'components/Maintainance/components'
import { MinimalInput } from 'components/Assets/components'
import { MinimalButtonGroup, MinimalButton } from 'components/common/buttons'
import { statusOptions } from './utils'
import facilities from 'Services/facilities/index'
import { validateSchema } from 'helpers/schemaValidation'

const AddBranch = ({ open, onClose, isEdit, reFetch, anchorObj }) => {
  const [branchData, setBranchData] = useState({
    companyBranchName: '',
    companyBranchCode: '',
    status: 1,
  })
  const [error, setError] = useState('')

  const handleInputChange = (name, value) => {
    setBranchData({ ...branchData, [name]: value })
  }

  const validateForm = async () => {
    const schema = yup.object().shape({
      companyBranchName: yup.string().required('Branch Name is required !'),
      companyBranchCode: yup.string().required('Branch Code is required !'),
    })
    const isValid = await validateSchema(branchData, schema)
    setError(isValid)
    if (isValid === true) submitData(branchData)
  }

  const postSuccess = () => {
    onClose()
    reFetch()
  }

  const { loading: isLoading, mutate: createBranch } = usePostData({ executer: facilities.branch.create, postSuccess, message: { success: !isEdit ? 'Branch created successfully!' : 'Branch updated successfully!', error: 'Something went wrong' } })

  const submitData = async payload => createBranch({ ...payload, status: branchData.status, companybranchId: !isEdit ? null : anchorObj.companybranchId })

  useEffect(() => {
    if (isEdit) {
      setBranchData({
        companyBranchName: get(anchorObj, 'companyBranchName', ''),
        companyBranchCode: get(anchorObj, 'companyBranchCode', ''),
        status: get(anchorObj, 'status', 1),
      })
    }
  }, [isEdit, anchorObj])

  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <FormTitle title={!isEdit ? 'Add Branch' : 'Edit Branch'} style={{ width: '100%', minWidth: '450px' }} closeFunc={onClose} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef', width: '450px' }}>
        <div style={{ padding: '10px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
            <MinimalInput value={get(branchData, 'companyBranchName', '') || ''} onChange={value => handleInputChange('companyBranchName', value)} error={error.companyBranchName} onFocus={() => setError({ ...error, companyBranchName: null })} label='Branch Name' placeholder='Enter Branch Name' w={100} />
            <MinimalInput value={get(branchData, 'companyBranchCode', '') || ''} onChange={value => handleInputChange('companyBranchCode', value)} error={error.companyBranchCode} onFocus={() => setError({ ...error, companyBranchCode: null })} label='Branch Code' placeholder='Enter Branch Code' w={100} />
            <MinimalButtonGroup label='Status' value={get(branchData, 'status', '') || ''} onChange={value => handleInputChange('status', value)} options={statusOptions} w={100} />
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center' style={{ borderTop: '1px solid #A6A6A6', borderBottom: 'none', background: '#fff', marginTop: 'auto', padding: '12px' }}>
        <MinimalButton variant='contained' color='default' text='Cancel' onClick={onClose} />
        <MinimalButton variant='contained' color='primary' text={!isEdit ? 'Add' : 'Update'} loadingText={!isEdit ? 'Adding...' : 'Updating...'} onClick={validateForm} disabled={isLoading} loading={isLoading} style={{ marginLeft: '10px' }} />
      </div>
    </Drawer>
  )
}

export default AddBranch
